import React from "react";
import {
  Box,
  Paper,
  Stack,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
  BoldIcon,
  TextItalicIcon,
  PaintBucketIcon,
  TextUnderlineIcon,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

const MultipleSelection = () => {
  const [formats, setFormats] = React.useState(() => ["bold", "italic"]);

  const handleFormat = (event, newFormats) => {
    setFormats(newFormats);
  };

  return (
    <Stack directio={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Multiple selection
        </Typography>
        <Typography variant={"body1"} color={"text.primary"}>
          Multiple selection allows for logically-grouped options, like bold,
          italic, and underline, to have multiple options selected.
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box mb={3}>
          <PreviewAndEditor
            language={"js"}
            value={
              "const Index = () => {\n" +
              '  const [formats, setFormats] = React.useState(() => ["bold", "italic"]);\n' +
              "\n" +
              "  const handleFormat = (event, newFormats) => {\n" +
              "    setFormats(newFormats);\n" +
              "  };\n" +
              "\n" +
              "  return (\n" +
              "    <ToggleButtonGroup\n" +
              "      value={formats}\n" +
              "      onChange={handleFormat}\n" +
              "    >\n" +
              '         <ToggleButton value="bold">\n' +
              "                <BoldIcon />\n" +
              "              </ToggleButton>\n" +
              '              <ToggleButton value="italic">\n' +
              "                <TextItalicIcon />\n" +
              "              </ToggleButton>\n" +
              '              <ToggleButton value="underlined">\n' +
              '                <TextUnderlineIcon sx={{color:"text.primary"}} />\n' +
              "              </ToggleButton>\n" +
              '              <ToggleButton value="color" disabled>\n' +
              "                <PaintBucketIcon />\n" +
              "              </ToggleButton>\n" +
              "         </ToggleButtonGroup>\n" +
              "  );\n" +
              "};\n"
            }
          >
            <ToggleButtonGroup value={formats} onChange={handleFormat}>
              <ToggleButton value="bold">
                <BoldIcon />
              </ToggleButton>
              <ToggleButton value="italic">
                <TextItalicIcon />
              </ToggleButton>
              <ToggleButton value="underlined">
                <TextUnderlineIcon sx={{ color: "text.primary" }} />
              </ToggleButton>
              <ToggleButton value="color" disabled>
                <PaintBucketIcon />
              </ToggleButton>
            </ToggleButtonGroup>
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default MultipleSelection;
